export default __webpack_public_path__ + "static/media/streamsowers-kohn-nigeria.236db11f.jpg";